import React from 'react';
import styles from './NumberPad.module.css'
import Button from "./Button";

const NumberPad = ({ value = "", onChange }) => {

  const handleClick = (digit) => onChange(`${value}${digit}`);
  const clearAll   = () => onChange("");
  const backSpace  = () => onChange(String(value).slice(0, -1));

  return (
    <div className={styles.gridTwoRows}>
      <Button title={"1"} variant={'light'}  onClick={() => handleClick(1)}/>
      <Button title={"2"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(2)}/>
      <Button title={"3"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(3)}/>
      <Button title={"4"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(4)}/>
      <Button title={"5"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(5)}/>
      <Button title={"6"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(6)}/>
      <Button title={"Borrar"} variant={'light'} style={{fontSize:"32px"}} onClick={() => clearAll()}/>
      <Button title={"7"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(7)}/>
      <Button title={"8"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(8)}/>
      <Button title={"9"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(9)}/>
      <Button title={"0"} variant={'light'} style={{fontSize:"32px"}} onClick={() => handleClick(0)}/>
      <Button title={"Back"} variant={'light'} style={{fontSize:"32px"}} onClick={() => backSpace()}/>
    </div>
  );
};

export default NumberPad;
